import { Link } from "react-router-dom";
import { Mail, MapPin, PhoneCall } from "lucide-react";
import { Logo } from "@/components/Logo";
import { CONTACT, SERVICES } from "@/lib/data";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-border bg-muted/40">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-4">
          <Logo />
          <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
            Reliable IT support, cloud, security and projects for growing businesses
            across Scotland's Central Belt. Clear, honest advice.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Services</p>
          <ul className="space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link to="/services" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Company</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/who-we-help" className="text-muted-foreground hover:text-foreground transition-colors">Who we help</Link></li>
            <li><Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors">About us</Link></li>
            <li><Link to="/faq" className="text-muted-foreground hover:text-foreground transition-colors">FAQ</Link></li>
            <li><Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">Contact</Link></li>
            <li>
              <a href={`mailto:${CONTACT.supportEmail}`} data-testid="footer-support-link" className="text-muted-foreground hover:text-foreground transition-colors">
                Existing client support
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Get in touch</p>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-center gap-2.5">
              <PhoneCall className="h-4 w-4 text-primary" />
              <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-foreground transition-colors">{CONTACT.phone}</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="h-4 w-4 text-primary" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-foreground transition-colors">{CONTACT.email}</a>
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin className="h-4 w-4 text-primary mt-0.5" />
              <span>{CONTACT.area}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-border pt-6">
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} Groundbreaking IT Ltd. All rights reserved.
        </p>
        <p className="text-xs text-muted-foreground font-mono tracking-wide">
          Scotland's Central Belt
        </p>
      </div>
    </div>
  </footer>
);
